import { useState, useRef, useEffect } from "react";
import { Image, Placeholder } from "semantic-ui-react";

export default function Testimonials(props) {
  const imgRef = useRef(null);
  const [state, setState] = useState(false);

  const onImageLoaded = () => setState(true);

  useEffect(() => {
    const imgElCurrent = imgRef.current;

    if (imgElCurrent) {
      imgElCurrent.addEventListener("load", onImageLoaded);
      return () => imgElCurrent.removeEventListener("load", onImageLoaded);
    }
  }, [imgRef]);

  function NewlineText(text) {

    const newText = text.split('\n').map(str => <p className={'cause-detail'}>{str}</p>);

    return newText;
  }

  const { name, photo, details } = props;
  return (
    <div className={"prev-social-cause"}>
      <div className={"image"}>
        <Placeholder className={'cause-photo'} style={{ display: state ? "none" : "block" }}>
          {/*<Placeholder.Image*/}
          {/*  as={"img"}*/}
          {/*  style={{ display: state ? "none" : "block" }}*/}
          {/*  className={"cause-photo"}*/}
          {/*/>*/}
        </Placeholder>

        <Image
          onLoad={onImageLoaded}
          size={"huge"}
          src={photo}
          className={"cause-photo"}
          style={{ display: state ? "block" : "none" }}
        />
        {/*<p className={'name'}>{name}</p>*/}
      </div>

      <div className={"details"}>
        <h1 className={"name"}>{name}</h1>
        {NewlineText(details)}
        {/*<p className={"cause-detail"}>{NewlineText(details)}</p>*/}
      </div>
    </div>
  );
}
